import { CrossRoundRedBgIcon, MasterCard, TickRoundGreenBgIcon, VisaCard } from '@shared/assets';
import { ERROR_CODES } from '@shared/constants/errorCodes';

import type { CardType, PaymentStatus } from '@features/PaymentsAndFinancial/Autopay/types/types';

export const AUTOPAY_LIMIT_OPTIONS = {
  asCharged: 'As Charged',
  setAutopayLimit: 'Set A Limit',
  setAutopayLimitNMA: 'Set A Limit (NMA)',
};

export const PROFILE_LANDING_PAGE_TITLE = 'AutoPay.About.Title';
export const PROFILE_LANDING_PAGE_MESSAGE = 'AutoPay.About.Content';

export const BILLDOWNLOAD = 'AutoPay.Notes.BillsDownloadYHC';
export const CONTACTINFO = 'AutoPay.Notes.ContactInfo';
export const INITIALCHARGE = 'AutoPay.Notes.InitialCharge';
export const INITIALCHARGESETUPDISCLAIMER = 'AutoPay.Notes.InitialChargeSetupDisclaimer';

export const AUTOPAY_TERMS_AND_CONDITIONS = 'AutoPay.TermsAndConditions.';

export const NUHS = 'NUHS';

export const ErrorCode = {
  CardRetrievalFail: ERROR_CODES.CARD_RETRIEVAL_FAIL,
  DefaultCard: ERROR_CODES.DEFAULT_CARD,
  MaximumCardLimit: ERROR_CODES.MAXIMUM_CARD_LIMIT,
  PatientNotFound1: ERROR_CODES.PATIENT_NOT_FOUND_1,
  PatientNotFound2: ERROR_CODES.PATIENT_NOT_FOUND_2,
  PatientNotFound3: ERROR_CODES.PATIENT_NOT_FOUND_3,
  SystemIssue: ERROR_CODES.SYSTEM_ISSUE,
} as const;

export type ErrorCodeType = (typeof ErrorCode)[keyof typeof ErrorCode];

export const ModalType = {
  LB0004: 'LB0004',
  MaximumCardLimit: 'MaximumCardLimit',
  None: '',
  PatientNotFound: 'PatientNotFound',
} as const;

export type ModalTypeType = (typeof ModalType)[keyof typeof ModalType];

export const STREET_MAXLEN = 40;
export const MPGS_SESSIONID_VERIFIER_STORAGE_KEY = 'mpgsSessionIdVerifier';
export const MPGS_NAVIGATE_QUERY_STRING_STORAGE_KEY = 'mpgsNavigateQueryString';
export const CARD_TYPE: Record<string, CardType> = {
  MASTERCARD: {
    image: MasterCard,
    name: 'MASTER',
    style: 'h-[31px]',
  },
  VISA: {
    image: VisaCard,
    name: 'VISA',
    style: 'h-[14px]',
  },
};

export const CARD_STATUS = {
  Default: 'Default',
  Expired: 'Expired',
};

export const RELATIONSHIP_OPTIONS = [
  {
    label: 'Child',
    value: 'child',
  },
  {
    label: 'Grandchild',
    value: 'grandchild',
  },
  {
    label: 'Grandparent',
    value: 'grandparent',
  },
  {
    label: 'Legal Guardian',
    value: 'guardian',
  },
  {
    label: 'Other Relative',
    value: 'relative',
  },
  {
    label: 'Others',
    value: 'others',
  },
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Siblings',
    value: 'sibling',
  },
  {
    label: 'Spouse',
    value: 'spouse',
  },
];

export const ERROR_MESSAGE_MAPPING: Record<string, string> = {
  AP0004: 'content.AP0004',
  AP0811: 'content.AP0811',
  AP0812: 'content.AP0812',
  E801: 'content.E801',
};

export const SETUP_CANCEL_CODE = 'cancel';

export const PaymentInfoQuery = {
  STATUS_CODE: 'statusCode',
} as const;

export const PAYMENT_STATUS_MAP: Record<string, PaymentStatus> = {
  success: {
    colour: 'bg-theme-500',
    icon: TickRoundGreenBgIcon,
    isSuccess: true,
    title: 'title.setupSuccess',
  },
  unsuccess: {
    colour: 'bg-secondary-red-1',
    icon: CrossRoundRedBgIcon,
    isSuccess: false,
    title: 'title.setupUnsuccess',
  },
};
